// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
require("@rails/ujs").start()
// import Turbolinks from "turbolinks"
import * as ActiveStorage from "@rails/activestorage"
import 'bootstrap'
global.toastr = require("toastr")
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;
require("packs/dashboard/simplebar.min.js")
// require("packs/dashboard/apexcharts.min.js")
// require("packs/dashboard/columnchart.init.js")
require("packs/dashboard/feather.min.js")
require("packs/dashboard/app-admin.js")
require("packs/dashboard/lightslider.js")
require("packs/dashboard/view-image.js")
require("packs/dashboard/jquery-file-upload.js")
require("dropzone")
ActiveStorage.start()
import LocalTime from "local-time"
LocalTime.start()
import $ from 'jquery';
import select2 from 'select2';
// import "./dashboard/jquery.multi-emails.js";
import 'select2/dist/css/select2.css';


function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

$(document).ready(function () {
    $('.select-2').select2({
        tags: true,
        maximumSelectionSize: 8
    });

    $('.networks').select2({
    });

    $('.user-select-2').select2({
    });

    $('.email-select-2').select2({
        tags: true,
        createTag: function(term, data) {
            var value = term.term;
            if(validateEmail(value)) {
                return {
                    id: value,
                    text: value
                };
            }
            return null;
        }
    });

    $('body').on('click', '.copy-link', function () {
        navigator.clipboard.writeText($(this).data('link'));
        toastr.success("Link copied")
    });
    // $("#email-addresses").multiEmails();
});
